import {useEffect, useState} from 'react'
import {useAuth} from '../../../../app/modules/auth'
import StockSummaryCard from '../../../../app/modules/administration/stock/components/StockSummaryCard'
import {getOperatorStockSummary} from '../../../../services/stock.service'
import {KTIcon} from '../../../../_metronic/helpers'

const OperatorStockPanel = () => {
  const {currentUser} = useAuth()

  const role = currentUser?.profile?.rol
  const zoneId = currentUser?.profile?.zone_id

  const [summary, setSummary] = useState<any>()
  const [loading, setLoading] = useState(false)
  const [lastUpdate, setLastUpdate] = useState<string>('')

  useEffect(() => {
    if (role !== 'operador' || !zoneId) return

    loadData()
  }, [zoneId])

  const loadData = async () => {
    try {
      setLoading(true)

      const data = await getOperatorStockSummary(zoneId)

      setSummary(data)

      setLastUpdate(
        new Date().toLocaleTimeString('es-VE', {
          hour: '2-digit',
          minute: '2-digit',
        })
      )
    } finally {
      setLoading(false)
    }
  }

  if (role !== 'operador') return null

  return (
    <div className='px-5 pb-8'>
      <div className='d-flex flex-column gap-4'>
        <StockSummaryCard color='success' title='Disponibles' value={summary?.disponibles ?? 0} />

        <StockSummaryCard color='warning' title='En Uso' value={summary?.enUso ?? 0} />

        <StockSummaryCard color='primary' title='Lavandería' value={summary?.lavanderia ?? 0} />

        <button className='btn btn-light-primary' onClick={loadData} disabled={loading}>
          <KTIcon iconName='arrows-circle' className='fs-3' />

          {loading ? 'Actualizando...' : 'Actualizar'}
        </button>

        {lastUpdate && <div className='text-muted fs-8'>Última actualización: {lastUpdate}</div>}
      </div>
    </div>
  )
}

export default OperatorStockPanel
